module.exports = __webpack_public_path__ + "static/img/14000798.02a0809c.png";